import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinKeyValueEditor',
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: true
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: null
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    },
    oneColLayout: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      mandatoryProperties: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    twinCanBeEdited: function twinCanBeEdited() {
      return this.hasTwinEditPermission && !this.dtwinIsDisabled && !this.cloading;
    },
    dtwinIsDisabled: function dtwinIsDisabled() {
      return get(this.twinObject, 'properties.disabled');
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      };
    }
  }),
  watch: {
    twinObject: function twinObject() {
      this.initialMetaDataSetup();
    }
  },
  created: function created() {
    this.initialMetaDataSetup();
  },
  methods: {
    get: get,
    initialMetaDataSetup: function initialMetaDataSetup() {
      var _this2 = this;

      if (!this.twinObject.data) {
        this.twinObject.data = {};
      }

      if (!this.twinObject.data.keyValue) {
        this.twinObject.data.keyValue = {};
      }

      if (this.twinObject.data.keyValue[''] === '') {
        delete this.twinObject.data.keyValue[''];
      }

      if (this.isCreatedByTemplate) {
        var templateCustomProperties = this.deviceTemplate.deviceMeta.customProperties;
        Object.keys(templateCustomProperties).forEach(function (cpKey) {
          if (templateCustomProperties[cpKey].requiredValue) {
            _this2.mandatoryProperties.push(cpKey);
          }
        });
      }
    },
    isTemplatePropertyMandatory: function isTemplatePropertyMandatory(key) {
      return this.mandatoryProperties.includes(key);
    },
    keyValueKeyChanged: function keyValueKeyChanged(prior, newKey) {
      var baseKey = newKey;
      var uniqueKey = newKey;
      var i = 0;

      while (this.twinObject.data.keyValue[uniqueKey] !== undefined) {
        i++;
        uniqueKey = "".concat(baseKey).concat(i);
      }

      this.twinObject.data.keyValue[uniqueKey] = this.twinObject.data.keyValue[prior];
      delete this.twinObject.data.keyValue[prior];
      this.twinObject.data = cloneDeep(this.twinObject.data);
    },
    addKeyValuePair: function addKeyValuePair() {
      if (this.twinObject.data.keyValue[''] === undefined) {
        this.twinObject.data.keyValue[''] = '';
      } else {
        var baseKey = 'Key';
        var uniqueKey = baseKey;
        var i = 0;

        while (this.twinObject.data.keyValue[uniqueKey] !== undefined) {
          i++;
          uniqueKey = "".concat(baseKey).concat(i);
        }

        this.twinObject.data.keyValue[uniqueKey] = '';
      }

      this.twinObject.data = cloneDeep(this.twinObject.data);
    },
    removeKeyValuePair: function removeKeyValuePair(key) {
      delete this.twinObject.data.keyValue[key];
      this.twinObject.data = cloneDeep(this.twinObject.data);
    }
  }
};